import React, { useContext } from 'react'

import { useDiscount } from './discount/use-discount'
import { DiscountBanner } from './discount'
import { useExperimentService } from '../../lib/hooks'
import { PageContext } from '../../contexts/page-context'
import { WorkweekWithAiBanner } from '@components/banner/workweek-with-ai'
import {
  isEligibleCompanyAnnouncement6_25Banner,
  isEligibleWorkweekWithAiBanner,
  isEligibleToolsSecondaryNav,
} from '@lib/utils/page-rules/by-slug'
import { CompanyAnnouncementBanner } from './company-announcement'
import { ToolsSecondaryNavBanner } from './tools-secondary-nav'

interface PageBannerProps {
  isDiscountBannerEnabled?: boolean
}

export const PageBanner: React.FC<PageBannerProps> = ({ isDiscountBannerEnabled }) => {
  const { discountValue } = useDiscount()

  return isDiscountBannerEnabled && discountValue ? <DiscountBanner discountValue={discountValue} /> : null
}

export const PostNavBanner: React.FC = () => {
  const exp = useExperimentService()
  const { slug } = useContext(PageContext)
  const mobileToolsNavEnabled = exp.getToolsSecondaryNavMobileAssignment() === 'test'

  if (isEligibleCompanyAnnouncement6_25Banner(slug) && exp.isCompanyAnnouncement6_25Enabled) {
    return <CompanyAnnouncementBanner />
  }
  if (isEligibleWorkweekWithAiBanner(slug) && exp.isSobcWorkweekWithAi_25Enabled) {
    return (
      <WorkweekWithAiBanner lightTheme={slug === 'business/customer-stories' || slug === 'ai-business-resource-hub'} />
    )
  }
  if (
    isEligibleToolsSecondaryNav(slug) &&
    (exp.getToolsSecondaryNavEnabled() === 'test' ||
      exp.getToolsSecondaryNavLoggedInEnabled() === 'test' ||
      mobileToolsNavEnabled)
  ) {
    return <ToolsSecondaryNavBanner mobileEnabled={mobileToolsNavEnabled} />
  }
  return null
}
